import React from 'react'
import PropTypes from 'prop-types'
import NutritionalTags from 'components/NutritionalTags';
import style from './style.scss'//NOSONAR


const NutritionalTable = (props) => {
    const { product } = props;
    let details = [];

    const newFlags = product && product.flag_details && product.flag_details.map((value) => {

        if(value === 'Porción' || value === 'Porciones' || value === 'Porción por envase' || value === 'Porciones por envase') {
            details.push({
                label: value,
                value: product[value]
            })

            return false;
        }

        return value;

    }).filter(Boolean);

    return (
        <>
            {(product.flag_details || product.flag_nutricional) &&
            <div className="product-page-container-nutritional-information">
                <div className="nutritional-information-container-title">
                    <span className="nutritional-information-title">Información Nutricional</span>
                </div>
                {product.flag_nutricional && <NutritionalTags tags={product.flag_nutricional}/>}
                {product.flag_details && product.flag_details.length > 0 && product.flag_details[0] !== 'Flag Nutricional' &&
                <div className="product-table-container">
                    <div className="product-page-container-nutritional-details">
                        {details.map((data, i) => {
                            return (
                                <div key={i}>
                                    <span className="nutritional-title-detail">{data.label}:</span>
                                    <span>{data.value}</span>
                                </div>
                            )
                        })}
                        <ul className="nutritional-details-container-title">
                            <li className="nutritional-details-title">Valores medios</li>
                            <li  className="title-quantity-grams"> <span>Por cada</span><span>100g/ml</span></li>
                            <li className="title-quantity-portion"><span>Por cada</span> <span>1 porción</span></li>
                        </ul>
                        {newFlags.map((value, i) => {
                            return (<ul key={i} className={'nutritional-details-container-data'}>
                                <li className="nutritional-details-title-data">{value}</li>

                                <li className="nutritional-details-value-data">
                                    {product[value].toString().indexOf('/') != -1 ?
                                        product[value].toString().substring(0, product[value].toString().indexOf('/')) :
                                        product[value].toString()} </li>

                                <li className="nutritional-details-value-data">{
                                    product[value].toString().indexOf('/') != -1 ?
                                        product[value].toString().substring((product[value].toString().indexOf('/') + 1), product[value].toString().length) :
                                        product[value].toString()}</li>
                            </ul>)
                        })}
                    </div>
                    <div className='nutritional-details-title-quantity-msg'>*Ingesta de referencia de un adulto promedio (8400 kj / 2000 kcal)</div>
                </div>}
            </div>}
        </>
    )
}

NutritionalTable.propTypes = {
    product: PropTypes.object,
}

export default NutritionalTable
